import idbs from '@/data/indexedDBService'
import API from '@/data/api.js'
import {getDaysInMonth} from 'date-fns'
import {store} from '@/store'

const DataMain = {
  async getUpdateDates () {
    if (store.state.key) {
      let updateDates = await API.getUpdateDates()
      let ret = {
        data: false,
        status: false
      }
      if (updateDates && updateDates.data && typeof updateDates.data === 'object') {
        updateDates.data.forEach(async function (u) {
          await idbs.saveToStorage('updateDate', {
            key: u.key,
            timestamp: u.timestamp
          })
          DataMain.syncServerTimes({key: u.key})
        })
        ret.data = updateDates.data
        ret.status = true
      }
      return ret
    }
  },

  async syncServerTimes (params) {
    return new Promise(async function (resolve, reject) {
      if (store.state.key) {
        let serverTime = await idbs.getItem('updateDate', 'key', params.key)
        let localTime = await idbs.getItem('updateDateLocal', 'key', params.key)
        let serverTimestamp = false
        if (serverTime && serverTime !== 'undefined' && serverTime.timestamp && serverTime.timestamp !== 'undefined') {
          serverTimestamp = serverTime.timestamp
        } else {
          serverTimestamp = Date.now()
          let newParams = {
            key: params.key,
            updateTimestamp: serverTimestamp
          }
          API.setUpdateTime(newParams)
        }
        if (serverTimestamp && params.key) {
          let localexists = false
          if (localTime && localTime !== 'undefined' && localTime.timestamp) { localexists = true }
          if (!localexists || serverTimestamp > localTime.timestamp) {
            // Update local if server time is newer
            await DataMain.serverToIndexedDB(params.key)
            idbs.saveToStorage('updateDateLocal', {
              key: params.key,
              timestamp: serverTimestamp
            })
          }

          if (localexists && serverTimestamp < localTime.timestamp) {
            await DataMain.indexedDBToServer(params.key)
          }
        }
      }
    })
  },

  async getData (params) {
    return new Promise(async function (resolve, reject) {
      let localTime = await idbs.getItem('updateDateLocal', 'key', params.indexDBInfo.key)
      let serverTime = await idbs.getItem('updateDate', 'key', params.indexDBInfo.key)
      let apiPull = true
      let localexists = false
      let data = false
      // if data is returned in local indexdb, set store
      if (localTime && localTime !== 'undefined') {
        const callbackInfo = params.indexDBInfo.callback
        localexists = true
        if (callbackInfo && callbackInfo.function && typeof DataMain[callbackInfo.function] === 'function') {
          if (callbackInfo.params) {
            await DataMain[callbackInfo.function](callbackInfo.params)
          } else {
            await DataMain[callbackInfo.function]()
          }
        }
        if (serverTime && serverTime !== 'undefined' && localexists) {
          if (localTime.timestamp === serverTime.timestamp) {
            apiPull = false
          } else if (localTime.timestamp > serverTime.timestamp) {
            apiPull = false
            await DataMain.indexedDBToServer(params.indexDBInfo.key)
          }
        }
      }

      if (apiPull) {
        DataMain.Load()

        const apiInfo = params.apiInfo
        if (apiInfo && apiInfo.function && typeof API[apiInfo.function] === 'function') {
          if (apiInfo.params) {
            data = {}
            data.data = await API[apiInfo.function](apiInfo.params)
          } else {
            data = {}
            data.data = await API[apiInfo.function]()
          }
          DataMain.Unload()

          if (apiInfo.callback && apiInfo.callback.function && typeof DataMain[apiInfo.callback.function] === 'function' && data) {
            data.params = apiInfo.callback.params
            await DataMain[apiInfo.callback.function](data)
          }
        } else {
          console.log('error with api call')
        }
      }
      resolve(data)
    })
  },

  async setData (params) {
    // get timestamp
    let updateTimestamp = Date.now()
    if (params.updateTimestamp) { updateTimestamp = params.updateTimestamp }
    let startParams = {updateTimestamp: updateTimestamp}

    // generate temporary key if necessary
    let tempkey = false
    if (params.temporary) {
      tempkey = await DataMain.randomString(10)
      tempkey = 'temp-' + tempkey
      params.idbInfo.key = tempkey
    }

    // save to store
    if (params.storeInfo && params.storeInfo.action && params.storeInfo.params) {
      if (params.temporary && !params.storeInfo.params.id) {
        params.storeInfo.params.activity.id = tempkey
      }
      store.commit(params.storeInfo.action, params.storeInfo.params)
    }

    // save to indexdb or delete
    if (params.idbInfo && params.idbInfo.action && params.idbInfo.action === 'delete') {
      idbs.deleteItem(params.idbInfo.store, params.idbInfo.key)
    } else {
      if (params.idbInfo && params.idbInfo.store && params.idbInfo.params && params.idbInfo.indexName && params.idbInfo.key) {
        let item = await idbs.getItem(params.idbInfo.store, params.idbInfo.indexName, params.idbInfo.key)
        if (!item) {
          item = {}
          if (params.temporary) { item.id = params.idbInfo.key }
        }
        for (let key in params.idbInfo.params) {
          item[key] = params.idbInfo.params[key]
        }
        idbs.saveToStorage(params.idbInfo.store, item)
      }
    }

    if (params.idbInfo && params.idbInfo.storeKey) {
      await idbs.saveToStorage('updateDateLocal', {
        key: params.idbInfo.storeKey,
        timestamp: updateTimestamp
      })
    }

    if (params.slug) {
      let APIParams = false
      if (params.APIParams) {
        APIParams = { ...startParams, ...params.APIParams }
      } else {
        APIParams = startParams
      }
      params.apiParams = APIParams
      let result = await API.getData(params)

      // TEMP CALLBACK IF APPROPRIATE
      if (tempkey) {
        let tempParams = {
          localKey: tempkey,
          idbInfo: params.idbInfo,
          result: result
        }
        if (params.tempCallback) {
          tempParams.tempCallback = params.tempCallback
        }

        await DataMain.handleTemporary(tempParams)
      }
    }
    API.getUpdateDates()
  },

  async indexedDBToServer (key) {
    let monthCheck = key.substr(0, 6) === 'month-'
    let data = {}
    if (monthCheck) {
      let month = key.substr(6)
      let yearmonthday = month + '-02' // use 02 to make sure it doesn't skip back to the last month
      let startDate = new Date(yearmonthday)
      let endNumber = getDaysInMonth(startDate)
      for (let i = 1; i <= endNumber; i++) {
        let j = i
        if (i < 10) { j = '0' + i }
        let day = month + '-' + j
        let newdata = await idbs.getItem('trackActivities', 'date', day)
        if (typeof newdata !== 'undefined') { data[day] = newdata }
      }
    } else {
      switch (key) {
        case 'activities':
          let activities = await idbs.checkStorage('activities')
          data = activities
          break
      }
    }
    if (Object.keys(data).length > 0) {
      let params = {
        apiParams: {
          'data': data, 'key': key
        },
        slug: 'api/activities/sync'
      }
      let localTime = await idbs.getItem('updateDateLocal', 'key', key)
      if (localTime && localTime.timestamp) {
        params.apiParams.updateTimestamp = localTime.timestamp
      }
      // await DataMain.setData(params)
      let result = await API.getData(params)
      if (result.tempreplace) {
        for (let r in result.tempreplace) {
          let existing = await idbs.getItem(key, 'id', r)
          existing.id = result.tempreplace[r]
          await idbs.saveToStorage(key, existing)
          await idbs.deleteItem(key, r)
          if (key === 'activities') {
            await DataMain.activitiesToStore()
          }
        }
      }
    }
  },

  async serverToIndexedDB (key) {
    let monthCheck = key.substr(0, 6) === 'month-'
    if (monthCheck) {
      let month = key.substr(6)
      let monthDay = month + '-02'
      await DataMain.getMonth(monthDay)
    } else {
      switch (key) {
        case 'activities':
          await DataMain.getActivities()
      }
    }
  },

  async getActivities () {
    try {
      let params = {
        indexDBInfo: {
          key: 'activities',
          callback: {
            function: 'activitiesToStore'
          }
        },
        apiInfo: {
          function: 'getActivities',
          callback: {
            function: 'activitiesToIndexedDB'
          }
        }
      }
      await DataMain.getData(params)
    } catch (err) {
      console.log(err)
    }
  },

  async getMonth (date) {
    let monthYear = date.slice(0, -3)
    try {
      let params = {
        indexDBInfo: {
          key: 'month-' + monthYear,
          callback: {
            function: 'monthActivitiesToStore',
            params: {
              month: monthYear
            }
          }
        },
        apiInfo: {
          function: 'getMonth',
          params: {
            month: monthYear
          },
          callback: {
            function: 'monthActivitiesToIndexedDB',
            params: {
              month: monthYear
            }
          }
        }
      }
      await DataMain.getData(params)
    } catch (err) {
      console.log(err)
    }
  },

  async activitiesToIndexedDB (data) {
    for (let d in data.data) {
      idbs.saveToStorage('activities', data.data[d])
    }
    let activities = await idbs.checkStorage('activities')
    /* Delete Temporary IDs */
    if (activities.length > 0) {
      activities.forEach(async function (activity) {
        let localid = activity.id
        let empty = true
        for (let d in data.data) {
          if (data.data[d].id === localid) {
            empty = false
            break
          }
        }
        if (empty) {
          await idbs.deleteItem('activities', localid)
        }
      })
    }
    // let local = idbs.get
    DataMain.activitiesToStore()
    DataMain.syncServerTimes({key: 'activities'})
  },

  async monthActivitiesToIndexedDB (data) {
    for (let d in data.data) {
      idbs.saveToStorage('trackActivities', {
        date: d,
        activities: data.data[d] }
      )
    }
    if (data.params.month) {
      let monthYear = data.params.month
      let storageKey = 'month-' + monthYear
      DataMain.monthActivitiesToStore({month: monthYear})
      DataMain.syncServerTimes({key: storageKey})
    }
  },

  async activitiesToStore () {
    let active = {}
    let inactive = {}
    let activities = await idbs.checkStorage('activities')
    if (activities.length > 0) {
      activities.forEach(function (activity) {
        if (activity.active * 1 === 1) {
          active[activity.id] = activity
        } else {
          inactive[activity.id] = activity
        }
      })
      store.commit('setActivities', {
        activities: {
          active: active,
          inactive: inactive
        }
      })
    }
  },

  async monthActivitiesToStore (params) {
    let yearmonthday = params.month + '-02' // use 02 to make sure it doesn't skip back to the last month
    store.commit('setMonthTracked', {
      month: params.month
    })
    let startDate = new Date(yearmonthday)
    let endNumber = getDaysInMonth(startDate)
    for (let i = 1; i <= endNumber; i++) {
      let a = []
      let j = i
      if (i < 10) { j = '0' + i }
      let day = params.month + '-' + j
      let data = await idbs.getItem('trackActivities', 'date', day)
      if (data && data.activities) {
        for (var ta in data.activities) {
          a.push(data.activities[ta] * 1)

          store.commit('addTrackingByActivity', {
            date: day,
            activity: data.activities[ta] * 1
          })
        }
      }
      store.commit('setTrackingDate', {
        date: day,
        activities: a
      })
    }
    /*
    let activities = store.state.activities.active

    for (var key in activities) {
      if (byActivity[key]) {
        store.commit('setTrackingByActivityMonth', {
          month: params.month,
          dates: byActivity[key],
          activity: key
        })
      }
    }
    */
  },

  async Load () {
    store.commit('setDataLoading', {active: true})
  },

  async Unload () {
    store.commit('setDataLoading', {active: false})
  },

  async syncActivities () {
    let updateDates = await DataMain.getUpdateDates()
    store.commit('serverStatus', {
      'status': updateDates.status
    })
  },

  async handleTemporary (params) {
    if (params.localKey && params.result) {
      if (params.idbInfo && params.idbInfo.store && params.idbInfo.storeKey && params.idbInfo.indexName && params.localKey && params.result) {
        let idbInfo = params.idbInfo
        let newdata = await idbs.getItem(idbInfo.storeKey, idbInfo.indexName, params.localKey)
        if (newdata) {
          // update idb
          await idbs.saveToStorage(idbInfo.store, params.result)
          await idbs.deleteItem(idbInfo.store, params.localKey)

          if (idbInfo.store === 'activities') {
            await DataMain.activitiesToStore()
          }
        }
      }
    }
  },

  async randomString (len) {
    let result = ''
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    let charactersLength = characters.length
    for (var i = 0; i < len; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },

  async setSyncCheck () {
    if (typeof this.syncCheck === 'undefined') {
      this.syncCheck = setInterval(function () {
        DataMain.syncActivities()
      }, 15000)
    }
  },

  async removeSyncCheck () {
    clearInterval(this.syncCheck)
    delete this.syncCheck
  }
}

export default DataMain



// WEBPACK FOOTER //
// ./src/data/dataMain.js